var RECAPTCHA_PUBLIC_KEY = typeof window !== 'undefined' ? window.RECAPTCHA_PUBLIC_KEY : null;
export var URLS = {
  wistia: 'https://fast.wistia.com/assets/external/E-v1.js',
  recaptha: RECAPTCHA_PUBLIC_KEY ? /*#__PURE__*/"https://www.google.com/recaptcha/api.js?render=".concat(RECAPTCHA_PUBLIC_KEY) : '',
  stripev2: 'https://js.stripe.com/v2/',
  paypal: 'https://www.paypalobjects.com/api/checkout.js',
  conekta: 'https://cdn.conekta.io/js/latest/conekta.js',
  ebanx: 'https://js.ebanx.com/ebanx-libjs-latest.min.js',
  vidyard: 'https://play.vidyard.com/embed/v4.js',
  payu: 'https://gateway.payulatam.com/ppp-web-gateway/javascript/PayU.js',
  youtube: 'https://www.youtube.com/iframe_api',
  rappi: 'https://microservices.dev.rappi.com/rms/merchant-services/sdk/rms.js'
};
var scriptsLoadedCache = [];
function loadScript(_ref) {
  var src = _ref.src,
    async = _ref.async,
    defer = _ref.defer;
  return new Promise(function (resolve, reject) {
    // check if it has already loaded
    if (scriptsLoadedCache.includes(src)) {
      resolve(true);
    } else {
      var js = document.createElement('script');
      js.src = src;
      js.type = 'text/javascript';
      if (async) {
        js.async = true;
      } else if (defer) {
        js.defer = true;
      }

      // set the callbacks before insert the script tag in the document
      js.onload = function () {
        resolve(true);
        scriptsLoadedCache.push(src);
      };
      js.onerror = reject;
      document.head.appendChild(js);
    }
  });
}
export default loadScript;